/*
  BOGO50 v1 measurement contract.
  Shopify's Google app remains the only source of add_to_cart,
  begin_checkout, and purchase. This file emits custom funnel events only.
*/
(function () {
  'use strict';

  var EVENT_VERSION = 'bogo50_v1';
  var CURRENCY = 'USD';
  var ELIGIBLE_HANDLES = {
    'whipped-tallow': true,
    'tallow-body-balm': true,
    'eye-serum': true,
    'tallow-trio-bundle': true,
    'freedom-balm': true,
    'nourishing-oil': true,
    'baby-balm': true
  };
  var latestCart = null;
  var lastBogoFingerprint = '';

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'bogo50-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function cleanUrl() {
    try {
      return window.location.origin + window.location.pathname;
    } catch (error) {
      return String(window.location.href || '').split(/[?#]/)[0];
    }
  }

  function readAttribution() {
    var stored = {};
    try {
      stored = JSON.parse(window.sessionStorage.getItem('tallOwlBogoAttribution') || '{}');
    } catch (error) {
      stored = {};
    }

    if (stored.source) {
      if (!stored.landing_url) {
        stored.landing_url = cleanUrl();
        try {
          window.sessionStorage.setItem('tallOwlBogoAttribution', JSON.stringify(stored));
        } catch (error) {
          /* Attribution remains available for this page. */
        }
      }
      return stored;
    }

    var params;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (error) {
      params = null;
    }

    var source = params ? String(params.get('utm_source') || '').slice(0, 80) : '';
    var medium = params ? String(params.get('utm_medium') || '').slice(0, 80) : '';
    if (!source && params && params.get('fbclid')) {
      source = 'facebook';
      medium = 'paid_social';
    } else if (!source && params && params.get('gclid')) {
      source = 'google';
      medium = 'cpc';
    }
    if (!source && document.referrer) {
      try {
        source = new URL(document.referrer).hostname.replace(/^www\./, '').slice(0, 80);
        medium = 'referral';
      } catch (error) {
        source = 'referral';
        medium = 'referral';
      }
    }
    if (!source) source = 'direct';
    if (!medium) medium = source === 'direct' ? 'none' : 'unknown';

    stored = { source: source, medium: medium, landing_url: cleanUrl() };
    try {
      window.sessionStorage.setItem('tallOwlBogoAttribution', JSON.stringify(stored));
    } catch (error) {
      /* Attribution remains available for this page. */
    }
    return stored;
  }

  function push(eventName, params) {
    var attribution = readAttribution();
    var payload = {
      event: eventName,
      event_id: eventId(),
      event_version: EVENT_VERSION,
      currency: CURRENCY,
      landing_url: attribution.landing_url || cleanUrl(),
      source: attribution.source,
      medium: attribution.medium
    };

    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value == null || value === '') return;
      if (/_id$/.test(key)) value = String(value);
      if (/_ids$/.test(key) && Array.isArray(value)) {
        value = value.map(function (item) {
          return String(item);
        });
      }
      payload[key] = value;
    });

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) {
      /* Measurement must never interrupt commerce. */
    }
  }

  function fetchCart() {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function isBogoAllocation(allocation) {
    var application = allocation && allocation.discount_application ? allocation.discount_application : {};
    var title = String(
      (allocation && allocation.title) ||
        application.title ||
        (allocation && allocation.discount_application && allocation.discount_application.title) ||
        ''
    ).toLowerCase();
    return title.indexOf('bogo 50') !== -1 || title.indexOf('bogos-') !== -1;
  }

  function bogoDetails(cart) {
    var savings = 0;
    var variantIds = [];
    var lineCount = 0;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var allocations = item.line_level_discount_allocations || item.discounts || [];
      var lineMatched = false;
      allocations.forEach(function (allocation) {
        if (!isBogoAllocation(allocation)) return;
        savings += Number(allocation.amount || allocation.total_allocated_amount || 0);
        lineMatched = true;
      });
      if (lineMatched) {
        lineCount += 1;
        variantIds.push(String(item.variant_id || item.id || ''));
      }
    });

    return {
      savings_cents: savings,
      discounted_line_count: lineCount,
      discounted_variant_ids: variantIds
    };
  }

  function eligibleUnitCount(cart) {
    return (cart && cart.items ? cart.items : []).reduce(function (count, item) {
      return ELIGIBLE_HANDLES[String(item.handle || '').toLowerCase()]
        ? count + Number(item.quantity || 0)
        : count;
    }, 0);
  }

  function reportBogo(cart) {
    if (!cart) return;
    latestCart = cart;
    var details = bogoDetails(cart);
    if (details.savings_cents <= 0) {
      lastBogoFingerprint = '';
      return;
    }

    var fingerprint = [
      Number(cart.total_price || 0),
      details.savings_cents,
      details.discounted_variant_ids.join(',')
    ].join(':');
    if (fingerprint === lastBogoFingerprint) return;
    lastBogoFingerprint = fingerprint;

    push('bogo_applied', {
      actual_savings_cents: details.savings_cents,
      discounted_line_count: details.discounted_line_count,
      discounted_line_variant_id: details.discounted_variant_ids[0] || '',
      discounted_variant_ids: details.discounted_variant_ids,
      cart_total_cents: Number(cart.total_price || 0)
    });
  }

  function sizeFromLabel(label) {
    var match = String(label || '').match(/\b(1\.5|2(?:\.0)?|3(?:\.0)?)\s*oz\b/i);
    return match ? match[0] : String(label || '').slice(0, 80);
  }

  function observeForView(element, eventName, parameters) {
    if (!element || element.getAttribute('data-bogo50-view-bound') === eventName) return;
    element.setAttribute('data-bogo50-view-bound', eventName);

    var timer = null;
    var done = false;
    var fire = function () {
      if (done) return;
      done = true;
      element.setAttribute('data-bogo50-view-fired', eventName);
      push(eventName, typeof parameters === 'function' ? parameters(element) : parameters);
    };

    if (!('IntersectionObserver' in window)) {
      var fallbackTimer = null;
      var visibleSince = 0;

      var fallbackCleanup = function () {
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        fallbackTimer = null;
        window.removeEventListener('scroll', fallbackCheck, true);
        window.removeEventListener('resize', fallbackCheck);
        document.removeEventListener('visibilitychange', fallbackCheck);
      };

      var fallbackRatio = function () {
        if (document.visibilityState === 'hidden') return 0;
        var rect = element.getBoundingClientRect();
        var elementArea = Math.max(0, rect.width) * Math.max(0, rect.height);
        if (elementArea <= 0) return 0;
        var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
        var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        return (visibleWidth * visibleHeight) / elementArea;
      };

      function fallbackCheck() {
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        fallbackTimer = null;
        if (done) {
          fallbackCleanup();
          return;
        }

        if (fallbackRatio() < 0.5) {
          visibleSince = 0;
          return;
        }

        if (!visibleSince) visibleSince = Date.now();
        var remaining = 500 - (Date.now() - visibleSince);
        if (remaining <= 0) {
          fallbackCleanup();
          fire();
          return;
        }
        fallbackTimer = window.setTimeout(fallbackCheck, Math.min(remaining, 100));
      }

      window.addEventListener('scroll', fallbackCheck, { passive: true, capture: true });
      window.addEventListener('resize', fallbackCheck, { passive: true });
      document.addEventListener('visibilitychange', fallbackCheck);
      fallbackCheck();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== element || done) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            if (!timer) {
              timer = window.setTimeout(function () {
                timer = null;
                fire();
                observer.disconnect();
              }, 500);
            }
          } else if (timer) {
            window.clearTimeout(timer);
            timer = null;
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );
    observer.observe(element);
  }

  function bindViewEvents(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-tall-owl-pdp-offer]').forEach(function (module) {
      observeForView(module, 'pdp_offer_view', function () {
        var variantLabel = module.querySelector('[data-tall-owl-pair-variant-label]');
        var sameButton = module.querySelector('[data-pair-type="same_variant"]');
        return {
          product_id: String(module.getAttribute('data-product-id') || ''),
          product_handle: String(module.getAttribute('data-product-handle') || ''),
          product_name: String(module.getAttribute('data-product-title') || '').slice(0, 120),
          variant_id: String(module.getAttribute('data-selected-variant-id') || ''),
          size: sizeFromLabel(variantLabel ? variantLabel.textContent : ''),
          pair_price_cents: Number(sameButton ? sameButton.getAttribute('data-pair-total-cents') : 0)
        };
      });
    });

    scope
      .querySelectorAll('.tall-owl-cart-ship:not(.tall-owl-cart-ship--unlocked), [data-tall-owl-threshold-nudge]')
      .forEach(function (nudge) {
        observeForView(nudge, 'cart_threshold_nudge_view', function () {
          var threshold = Number(nudge.getAttribute('data-threshold-cents') || 5000);
          var subtotal = Number(nudge.getAttribute('data-subtotal-cents') || 0);
          var suggestedVariant = String(nudge.getAttribute('data-suggested-variant-id') || '');
          if (!suggestedVariant) {
            var suggestion = document.querySelector(
              '[data-tall-owl-threshold-nudge][data-suggested-variant-id], [data-tall-owl-cart-xs-add][data-variant-id]'
            );
            suggestedVariant = String(suggestion ? suggestion.getAttribute('data-suggested-variant-id') || suggestion.getAttribute('data-variant-id') || '' : '');
          }
          return {
            amount_remaining_cents: Math.max(0, threshold - subtotal),
            suggested_variant_id: suggestedVariant || 'none_available'
          };
        });
      });
  }

  function browserContext() {
    var ua = String(window.navigator.userAgent || '');
    if (/FBAN|FBAV/i.test(ua)) return 'facebook_webview';
    if (/Instagram/i.test(ua)) return 'instagram_webview';
    if (/Shopify|ShopApp|Shop\//i.test(ua)) return 'shop_webview';
    if (/CriOS|Chrome/i.test(ua)) return 'chrome';
    if (/Safari/i.test(ua)) return 'safari';
    return 'other';
  }

  document.addEventListener('tallowl:pair-click', function (event) {
    var detail = (event && event.detail) || {};
    push('bogo_pair_click', {
      product_id: String(detail.product_id || ''),
      base_variant_id: String((detail.variant_ids || [])[0] || ''),
      partner_variant_id: String((detail.variant_ids || [])[1] || (detail.variant_ids || [])[0] || ''),
      pair_type: detail.pair_type,
      placement: String(detail.placement || 'pdp_buy_box'),
      pair_total_cents: Number(detail.pair_total_cents || 0),
      expected_savings_cents: Number(detail.pair_savings_cents || 0)
    });
  });

  document.addEventListener('tallowl:pair-added', function (event) {
    var detail = (event && event.detail) || {};
    push('bogo_pair_added', {
      product_id: String(detail.product_id || ''),
      variant_ids: detail.variant_ids || [],
      pair_type: detail.pair_type,
      placement: String(detail.placement || 'pdp_buy_box'),
      expected_savings_cents: Number(detail.pair_savings_cents || 0),
      cart_total_cents: Number(detail.cart_total_cents || 0)
    });
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    if (cart) reportBogo(cart);
    bindViewEvents(document);
  });

  document.addEventListener('cart:build', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    if (cart) reportBogo(cart);
    bindViewEvents(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindViewEvents(event && event.target ? event.target : document);
  });

  var drawerWasOpen = document.documentElement.classList.contains('js-drawer-open');
  document.addEventListener('drawerOpen.CartDrawer', function () {
    if (drawerWasOpen) return;
    drawerWasOpen = true;
    var onCart = function (cart) {
      latestCart = cart;
      push('cart_drawer_view', {
        eligible_unit_count: eligibleUnitCount(cart),
        cart_total_cents: Number(cart.total_price || 0)
      });
      reportBogo(cart);
      bindViewEvents(document);
    };
    if (latestCart) onCart(latestCart);
    else fetchCart().then(onCart).catch(function () {});
  });

  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!document.documentElement.classList.contains('js-drawer-open')) drawerWasOpen = false;
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener(
    'click',
    function (event) {
      var checkout = event.target.closest && event.target.closest('button[name="checkout"], .cart__checkout');
      if (!checkout) return;
      var details = bogoDetails(latestCart || {});
      var serverSummary = document.querySelector('[data-tall-owl-bogo-summary]');
      var serverSavings = Number(serverSummary ? serverSummary.getAttribute('data-bogo-savings-cents') : 0);
      var cartTotal = Number(latestCart && latestCart.total_price ? latestCart.total_price : 0);
      var cartHook = document.querySelector('[data-tall-owl-cart-server-summary]');
      if (!cartTotal && cartHook) cartTotal = Number(cartHook.getAttribute('data-cart-total-cents') || 0);
      push('checkout_click', {
        cart_total_cents: cartTotal,
        actual_savings_cents: details.savings_cents || serverSavings,
        browser_context: browserContext()
      });
    },
    true
  );

  readAttribution();
  bindViewEvents(document);
  fetchCart()
    .then(function (cart) {
      reportBogo(cart);
    })
    .catch(function () {});
})();
